/**
 *
 * PortalCheckbox
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 13-Oct-2022
 */

import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { generateUniqueId } from 'Utility/generateUniqueID';
import style from './PortalCheckbox.scss';

const PortalCheckbox = (props) => (
	<FormControlLabel
		className={style.container}
		control={
			<Checkbox
				name={props.label}
				color='primary'
				className={style.checkbox}
				disabled={props.disabled}
				checked={props.checked}
				onClick={props.onClick}
				onClickCapture={props.onClickCapture}
				value={props.value}
				id={props.id}
			/>
		}
		label={props.label}
	/>
);

PortalCheckbox.propTypes = {
	label: PropTypes.string,
	onClick: PropTypes.func,
	onClickCapture: PropTypes.func,
	disabled: PropTypes.bool,
	checked: PropTypes.bool,
	value: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

PortalCheckbox.defaultProps = {
	label: '',
	onClick: () => {},
	onClickCapture: () => {},
	disabled: false,
	checked: false,
	id: generateUniqueId(),
};

export default PortalCheckbox;
